/** 
  All of the routes for the   React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

//   React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Employee from "layouts/EmployeeUpdate";
import IconDashboard from "@mui/icons-material/Dashboard";
import IconShoppingCart from "@mui/icons-material/ShoppingCart";
import IconPeople from "@mui/icons-material/People";
import IconBarChart from "@mui/icons-material/BarChart";
import IconLibraryBooks from "@mui/icons-material/LibraryBooks";

// @mui icons
import Icon from "@mui/material/Icon";
import Appraisal_Form from "layouts/Appraisal_Form";
import ViewRatings from "layouts/ViewRatings";
import Resignation from "layouts/Resignation";
import PolicyDocuments from "layouts/PolicyDocuments";
import EmployeeReferralBonusDocument from "layouts/EmployeeReferralBonusdocument";
import LMSPolicyDocument from "layouts/LeaveManagement/LMSPolicyDocuments";
import ApplyLeave from "layouts/LeaveManagement/ApplyLeave";
import LeaveRequestList from "layouts/LeaveManagement/LeaveRequestList";
import GenerateCompensatoryOff from "layouts/LeaveManagement/GenerateCompensatoryOff";
import ApplyMaternityLeaves from "layouts/LeaveManagement/ApplyMaternityLeaves";
import ListCompensatoryOff from "layouts/LeaveManagement/ListCompensatoryOff";
import Gallery from "layouts/Gallery";
import LMSPolicyDocuments from "layouts/LeaveManagement/LMSPolicyDocuments";
import {DisplaySettings, Visibility} from "@mui/icons-material";
import Logout from "examples/Sidenav/Logout";
import LeaveApplicationReceived from "layouts/LeaveManagement/LeaveApplicationReceived";
import CompensatoryRequestReceived from "layouts/LeaveManagement/CompensatoryRequestReceived";
import KRA_form_overview from "layouts/Appraisal_Form/KRA_form_overview";
import List_technical_skills from "layouts/Appraisal_Form/List_technical_skills";
import Add_technical_skills from "layouts/Appraisal_Form/Add_technical_skills";
import KRA_status from "layouts/Appraisal_Form/KRA_Status";
import Performance_Improvement_List from "layouts/Appraisal_Form/Performance_Improvement_List";
import Resignation_Request_List from "layouts/Resignation Request/Resignation_Request_List";
import Probation_List from "layouts/Probation_Period/Probation_List";
import OfferList from "layouts/Admin/OfferLetter/OfferList";
import CreateNewOffer from "layouts/Admin/OfferLetter/CreateNewOffer";
import EmployeeList from "layouts/Admin/Employee/EmployeeList";
import AppointmentList from "layouts/Admin/AppointmentLetter/AppointmentList";
import IssueAppoinmentLetter from "layouts/Admin/OfferLetter/IssueAppoinmentLetter";
import CancelOfferLetter from "layouts/Admin/OfferLetter/CancelOfferLetter";
import EditPermissions from "layouts/Admin/Employee/EditPermissions";
import ChangePassword from "layouts/Admin/Employee/ChangePassword";
import UpdateOffer from "layouts/Admin/OfferLetter/CreateNewOffer";
import AddToRoaster from "layouts/Admin/Employee/AddToRoaster";
import Leaving from "layouts/Admin/Employee/Leaving";
import Reporting from "layouts/Admin/Employee/Reporting";
import SalaryRevision from "layouts/Admin/Employee/SalaryRevision";
import AppointmentLetter from "layouts/Admin/Employee/AppointmentLetter";
import SalaryCertificate from "layouts/Admin/Employee/SalaryCertificate";
import ApplyResignation from "layouts/Admin/Employee/ApplyResignation";
import CTCHistory from "layouts/Admin/Employee/CTC_History";
import AddressCertificate from "layouts/Admin/Employee/AddressCertificate";
import BonafideCertificate from "layouts/Admin/Employee/BonafideCertificate";
import HideLocation from "layouts/Admin/Employee/HideLocation";
import AssignProject from "layouts/Admin/Employee/AssignProject";
import AdminLeaveRequest from "layouts/Admin/LeaveManagement/AdminLeaveRequest";
import ResignationRequestList from "layouts/Admin/ResignationRequest/ResignationRequestList";
import AdminListCompensatoryOff from "layouts/Admin/LeaveManagement/AdminListCompensatoryOff";
import AdminApplyLeave from "layouts/Admin/LeaveManagement/AdminApplyLeave";
import AssignCompensatoryOff from "layouts/Admin/LeaveManagement/AssignCompensatoryOff";
import ProtectedRoute from "ProtectedRoute";
import Experience_Reports from "layouts/Reports/Experience_Reports";
import ExperienceReport from "layouts/Admin/Reports/ExperienceReport";
import ReportingList from "layouts/Admin/Reports/ReportingList";
import BalanceLeaveReport from "layouts/Admin/Reports/BalanceLeaveReport";
import ReportingEmployees from "layouts/dashboard/ReportingEmployees";
import AddProject from "layouts/Admin/Project/AddProject";
import ProjectList from "layouts/Admin/Project/ProjectList";
import AddClient from "layouts/Admin/Project/AddClient";
import ClientList from "layouts/Admin/Project/ClientList";
import LWPLeaveReport from "layouts/Admin/Reports/LWPLeaveReport";
import ProjectReport from "layouts/Admin/Reports/ProjectReport";
import BiometricLeaveReport from "layouts/Admin/Reports/BiometricLeaveReport";
import AdminProbationReport from "layouts/Admin/Reports/AdminProbationReport";
import EmployeeBillingReport from "layouts/Admin/Reports/EmployeeBillingReport";
import AdminJoiningReport from "layouts/Admin/Reports/AdminJoiningReport";
import ProbationEmployeeList from "layouts/Probation_Period/Probation_List";
import EmployeeProbationList from "layouts/Probation_Period/Probation_List";
import ExtendProbation from "layouts/Probation_Period/ExtendProbation";
import ChangeNoticePeriod from "layouts/Admin/Reports/ChangeNoticePeriod";
import AdminExtendProbation from "layouts/Admin/Reports/AdminExtendPrbation";
import EndProbation from "layouts/Probation_Period/EndProbation";
import AdminEndProbation from "layouts/Admin/Reports/AdminEndProbation";
import TechnologyReport from "layouts/Admin/Reports/TechnologyReport";
import DefaulterList from "layouts/Admin/Reports/DefaulterList";
import Temp_biom_dataReport from "layouts/Admin/Reports/Temp_biom_dataReport";
import EmployeeAttendanceeReport from "layouts/Admin/Reports/EmployeeAttendanceeReport";
import EmployeeRosterReport from "layouts/Admin/Reports/EmployeeRosterReport";
import PerformanceAppraisalReport from "layouts/Admin/Reports/PerformanceAppraisalReport";

import AddJobVacancy from "layouts/Admin/JobVacancy/AddJobVacancy";
import JobVacancyList from "layouts/Admin/JobVacancy/JobVacancyList";
import AddYoutubeLinks from "layouts/Admin/YoutubeLinks/AddYoutubeLinks";
import YoutubeLinksList from "layouts/Admin/YoutubeLinks/YoutubeLinksList";
import VoucherWindow from "layouts/Admin/DiwaliVoucher/VoucherWindow";
import UploadVouchers from "layouts/Admin/DiwaliVoucher/UploadVouchers";
import ReportingHistory from "layouts/Admin/Employee/ReportingHistory";
import CronJobLinks from "layouts/Admin/Setting/CronJobLinks";
import RevokeOfferLetter from "layouts/Admin/OfferLetter/RevokeOfferLetter";
import CreatePerformanceImprovement from "layouts/Admin/PerformanceImprovement/CreatePerformanceImprovement";
import PerformanceImprovementList from "layouts/Admin/PerformanceImprovement/PerformanceImprovementList";
import ExtendPerformanceImprovement from "layouts/Admin/PerformanceImprovement/ExtendPerformanceImprovement";
import EndPerformanceImprovement from "layouts/Admin/PerformanceImprovement/EndPerformanceImprovement";
import SetPermissions from "layouts/Admin/Setting/SetPermissions";
import AppraisalViewRating from "layouts/Appraisal_Form/AppraisalViewRating";
import PerformanceForm from "layouts/Appraisal_Form/PerformanceForm";
import ReportingEmployeesList from "layouts/ReportingEmployeesList/ReportingEmployeesList";

import OpenKRAWindow from "layouts/Admin/PerformanceAppraisal/OpenKRAWindow";
import KraFormOverview from "layouts/Admin/PerformanceAppraisal/KraFormOverview";
import AddSkills from "layouts/Admin/PerformanceAppraisal/AddSkills";
import ListSkills from "layouts/Admin/PerformanceAppraisal/ListSkills";
import StatusReport from "layouts/Admin/PerformanceAppraisal/StatusReport";
import ExtendKra from "layouts/Admin/PerformanceAppraisal/ExtendKra";
import DefaultValues from "layouts/Admin/Setting/DefaultValues";
import ProcessAttendanceData from "layouts/Admin/Setting/ProcessAttendanceData";
import BirthdayTemplateUpload from "layouts/Admin/Setting/BirthdayTemplateUpload";
import Event from "layouts/Admin/Setting/Event";
import AdminPermissions from "layouts/Admin/Setting/AdminPermissions";
import AdminChangePassword from "layouts/Admin/Employee/AdminChangePassword";
import ChangeEmployeePassword from "layouts/EmployeePassword/ChangeEmployeePassword";
import ForgotPassword from "layouts/authentication/reset-password/cover";
import AssetManagement from "layouts/IT_Dept/AssetManagement";
import AddAsset from "layouts/IT_Dept/AssetManagement/AddAsset";
import AddComponent from "layouts/IT_Dept/AssetManagement/AddComponent";
import AssetList from "layouts/IT_Dept/AssetManagement/AssetList";
import ViewAsset from "layouts/IT_Dept/AssetManagement/ViewAsset";
import IssueAsset from "layouts/IT_Dept/AssetManagement/IssueAsset";
import AssetHistory from "layouts/IT_Dept/AssetManagement/AssetHistory";
import ReceiveAsset from "layouts/IT_Dept/AssetManagement/ReceiveAsset";
import EmployeeAssetsHistory from "layouts/EmployeeAssetsHistory";
import ITHelpdesk from "layouts/IT_Dept/Helpdesk/ITHelpdesk";
import ExtendKraForEmployee from "layouts/Admin/PerformanceAppraisal/ExtendKraForEmployee";
// import { name } from "../public/pwa-config";
import ExitClearanceForm from "layouts/exitClearance/ExitClearanceForm";
import icon from "assets/theme/components/icon";
import ITClearanceList from "layouts/exitClearance/ITClearance/ITClearanceList";
import FinanceClearanceList from "layouts/exitClearance/finance/FinanceClearanceList";
import AdministrationClearanceList from "layouts/exitClearance/adminstration/AdministrationClearanceList";
import HRClearanceList from "layouts/exitClearance/hrClearance/HRClearanceList";
import ExitInterviewForm from "layouts/exitClearance/ExitInterviewForm";
import ExitInterviewList from "layouts/exitClearance/hrClearance/ExitInterviewList";
import AssignKRA from "layouts/Appraisal_Form/AssignKRA";
import ConfirmationPage from "layouts/Appraisal_Form/ConfirmationPage";
import KRAList from "layouts/Appraisal_Form/KRAList";
import EditGoalSettings from "layouts/Appraisal_Form/EditGoalSettings";
import GoalSettingsView from "layouts/Appraisal_Form/GoalSettingsView";
import ViewEmployeeRatings from "layouts/Appraisal_Form/ViewEmployeeRatings";
import AdminViewAppraisalForm from "layouts/Admin/PerformanceAppraisal/AdminViewAppraisalForm";
import WorkAnniversaryList from "layouts/dashboard/WorkAnniversaryList";

const routes = [
  {
    name: "Dashboard",
    route: "/dashboard",
    key: "dashboard",
    Icon: IconDashboard,
    component: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    )
  },
  {
    name: "View Details",
    route: "/profile",
    key: "View Details",
    icon: <Icon fontSize="small">dashboard</Icon>,
    component: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    )
  },
  {
    name: "Update",
    route: "/employee",
    key: "Update",
    icon: <Icon fontSize="small">dashboard</Icon>,
    component: (
      <ProtectedRoute>
        <Employee />
      </ProtectedRoute>
    )
  },
  {
    name: "Employee",
    Icon: IconPeople,
    key: "employee",
    items: [
      {
        name: "View Details",
        route: "/profile",
        component: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        )
      },
      {
        name: "Update",
        route: "/employee",
        component: (
          <ProtectedRoute>
            <Employee />
          </ProtectedRoute>
        )
      },
      {
        name: "Appraisal Form",
        route: "/evaluationpolicy",
        component: (
          <ProtectedRoute>
            <Appraisal_Form />
          </ProtectedRoute>
        )
      },
      // {
      //   name: "View Ratings",
      //   route: "/viewRatings",
      //   component: <ViewRatings />,
      // },
      {
        name: "Resignation",
        route: "/resignation",
        component: (
          <ProtectedRoute>
            <Resignation />
          </ProtectedRoute>
        )
      },
      {
        name: "Policy Documents",
        route: "/policyDocuments",
        component: (
          <ProtectedRoute>
            <PolicyDocuments />
          </ProtectedRoute>
        )
      },
      {
        name: "Employee Referral Bonus",
        route: "/employeeReferralBonusDocument",
        component: (
          <ProtectedRoute>
            <EmployeeReferralBonusDocument />
          </ProtectedRoute>
        )
      },
      {
        name: "View Ratings",
        route: "/viewRatings",
        component: (
          <ProtectedRoute>
            <ViewRatings />
          </ProtectedRoute>
        )
      }
    ]
  },
  {
    name: "Leave Management",
    Icon: IconBarChart,
    key: "leaveManagement",
    items: [
      {
        name: "LMS Policy Document",
        route: "/lMSPolicyDocument",
        component: (
          <ProtectedRoute>
            <LMSPolicyDocuments />
          </ProtectedRoute>
        )
      },
      {
        name: "Apply for Leave",
        route: "/applyLeave",
        component: (
          <ProtectedRoute>
            <ApplyLeave />
          </ProtectedRoute>
        )
      },
      {
        name: "Leave Request List",
        route: "/leaveRequestList",
        component: (
          <ProtectedRoute>
            <LeaveRequestList />
          </ProtectedRoute>
        )
      },
      {
        name: "Generate Compensatory Off",
        route: "/generateCompensatoryOff",
        component: (
          <ProtectedRoute>
            <GenerateCompensatoryOff />
          </ProtectedRoute>
        )
      },
      {
        name: "Apply Maternity Leaves",
        route: "/applyMaternityLeaves",
        component: (
          <ProtectedRoute>
            <ApplyMaternityLeaves />
          </ProtectedRoute>
        )
      },
      {
        name: "List Compensatory Off",
        route: "/listCompensatoryOff",
        component: (
          <ProtectedRoute>
            <ListCompensatoryOff />
          </ProtectedRoute>
        )
      },
      {
        name: "Leave Application Received",
        route: "/leaveApplicationReceived",
        component: (
          <ProtectedRoute>
            <LeaveApplicationReceived />
          </ProtectedRoute>
        )
      },
      {
        name: "Compensatory Request Received",
        route: "/compensatoryRequestReceived",
        component: (
          <ProtectedRoute>
            <CompensatoryRequestReceived />
          </ProtectedRoute>
        )
      }
    ]
  },
  {
    name: "Gallery",
    route: "/gallery",
    Icon: IconLibraryBooks,
    key: "gallery",
    component: (
      <ProtectedRoute>
        <Gallery />
      </ProtectedRoute>
    )
  },

  {
    name: "Create New",
    key: "Create New",
    route: "/offer",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <CreateNewOffer />
      </ProtectedRoute>
    )
  },
  {
    name: "update offer",
    key: "update offer",
    route: "/editOffer",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <UpdateOffer />
      </ProtectedRoute>
    )
  },
  {
    name: "update offer",
    key: "update offer",
    route: "/viewOffer",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <UpdateOffer />
      </ProtectedRoute>
    )
  },
  {
    name: "List",
    key: "EmployeeList",
    route: "/Employee_List",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <EmployeeList />
      </ProtectedRoute>
    )
  },
  {
    name: "EditPermissions",
    key: "EditPermissions",
    route: "/EditPermissions",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <EditPermissions />
      </ProtectedRoute>
    )
  },
  {
    name: "ChangePassword",
    key: "ChangePassword",
    route: "/changePassword",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <ChangePassword />
      </ProtectedRoute>
    )
  },
  {
    name: "Admin Change Password",
    key: "Admin Change Password",
    route: "/adminChangePassword",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AdminChangePassword />
      </ProtectedRoute>
    )
  },
  {
    name: "Add To Roaster",
    key: "AddToRoaster",
    route: "/AddToRoaster",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AddToRoaster />
      </ProtectedRoute>
    )
  },
  {
    name: "Salary Revision",
    key: "SalaryRevision",
    route: "/salaryRevision",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <SalaryRevision />
      </ProtectedRoute>
    )
  },
  {
    name: "Reporting",
    key: "Reporting",
    route: "/reporting",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <Reporting />
      </ProtectedRoute>
    )
  },
  {
    name: "Leaving",
    key: "Leaving",
    route: "/exit",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <Leaving />
      </ProtectedRoute>
    )
  },
  {
    name: "AppointmentLetter",
    key: "AppointmentLetter",
    route: "/appointmentLetter",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AppointmentLetter />
      </ProtectedRoute>
    )
  },
  {
    name: "SalaryCertificate",
    key: "SalaryCertificate",
    route: "/salaryCertificate",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <SalaryCertificate />
      </ProtectedRoute>
    )
  },
  {
    name: "AddressCertificate",
    key: "AddressCertificate",
    route: "/addressCertificate",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AddressCertificate />
      </ProtectedRoute>
    )
  },
  {
    name: "BonafideCertificate",
    key: "BonafideCertificate",
    route: "/bonafideCertificate",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <BonafideCertificate />
      </ProtectedRoute>
    )
  },
  {
    name: "Assign Project",
    key: "Assign Project",
    route: "/assignProject",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AssignProject />
      </ProtectedRoute>
    )
  },
  {
    name: "Client",
    key: "Client",
    route: "/addClient",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AddClient />
      </ProtectedRoute>
    )
  },
  {
    name: "Client",
    key: "Client",
    route: "/clientList",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <ClientList />
      </ProtectedRoute>
    )
  },
  {
    name: "Add Project",
    key: "Add Project",
    route: "/addProject",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AddProject />
      </ProtectedRoute>
    )
  },
  {
    name: "Project List",
    key: "Project List",
    route: "/projectList",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <ProjectList />
      </ProtectedRoute>
    )
  },
  {
    name: "Hide Location",
    key: "Hide Location",
    route: "/hideLocation",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <HideLocation />
      </ProtectedRoute>
    )
  },
  {
    name: "CTCHistory",
    key: "CTCHistory",
    route: "/ctc_History",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <CTCHistory />
      </ProtectedRoute>
    )
  },

  {
    name: "ApplyResignation",
    key: "ApplyResignation",
    route: "/applyResignation",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <ApplyResignation />
      </ProtectedRoute>
    )
  },

  {
    name: "List",
    key: "OfferList",
    route: "/Offer_List",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <OfferList />
      </ProtectedRoute>
    )
  },
  {
    name: "IssueAppoinmentLetter",
    key: "IssueAppoinmentLetter",
    route: "/IssueAppoinmentLetter",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <IssueAppoinmentLetter />
      </ProtectedRoute>
    )
  },
  {
    name: "CancelOfferLetter",
    key: "CancelOfferLetter",
    route: "/CancelOfferLetter",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <CancelOfferLetter />
      </ProtectedRoute>
    )
  },

  {
    name: "Revoke Offer Letter",
    key: "Revoke Offer Letter",
    route: "/revokeOfferLetter",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <RevokeOfferLetter />
      </ProtectedRoute>
    )
  },

  {
    name: "List",
    key: "AdminApplyLeave",
    route: "/adminApplyLeave",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AdminApplyLeave />
      </ProtectedRoute>
    )
  },
  {
    name: "List",
    key: "AdminLeaveRequest",
    route: "/adminLeaveRequest",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AdminLeaveRequest />
      </ProtectedRoute>
    )
  },

  {
    name: "List",
    key: "AdminListCompensatoryOff",
    route: "/AdminListCompensatoryOff",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AdminListCompensatoryOff />
      </ProtectedRoute>
    )
  },

  {
    name: "List",
    key: "AppointmentList",
    route: "/AppointmentList",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AppointmentList />
      </ProtectedRoute>
    )
  },
  {
    name: "Appraisal Form",
    key: "Appraisal_Form",
    icon: <Icon fontSize="small">Appraisal_Form</Icon>,
    route: "/evaluationpolicy",
    component: (
      <ProtectedRoute>
        <Appraisal_Form />
      </ProtectedRoute>
    )
  },
  {
    name: "Add Technical Skills",
    key: "Add Technical Skills",
    route: "/add_technical_skills",
    icon: <Icon fontSize="small">person</Icon>,
    component: (
      <ProtectedRoute>
        <Add_technical_skills />
      </ProtectedRoute>
    )
  },
  {
    name: "List Technical Skills",
    key: "List Technical Skills",
    route: "/list_technical_skills",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <List_technical_skills />
      </ProtectedRoute>
    )
  },
  {
    name: "KRA Form Overview",
    key: "KRA Form Overview",
    route: "/manager/appraisal/kra_form_overview/:appraisalId/:empId",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <KRA_form_overview />
      </ProtectedRoute>
    )
  },
  {
    name: "KRA Status",
    key: "KRA Status",
    route: "/kra_status",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <KRA_status />
      </ProtectedRoute>
    )
  },
  {
    name: "View Ratings",
    key: "View_Ratings",
    icon: <Icon fontSize="small">View Ratings</Icon>,
    route: "/viewRatings",
    component: (
      <ProtectedRoute>
        <ViewRatings />
      </ProtectedRoute>
    )
  },
  {
    name: "Add Technical Skills",
    key: "Add Technical Skills",
    route: "/add_technical_skills",
    icon: <Icon fontSize="small">person</Icon>,
    component: (
      <ProtectedRoute>
        <Add_technical_skills />
      </ProtectedRoute>
    )
  },
  {
    name: "Resignation",
    key: "Resignation",
    icon: <Icon fontSize="small">Resignation</Icon>,
    route: "/resignation",
    component: (
      <ProtectedRoute>
        <Resignation />
      </ProtectedRoute>
    )
  },

  {
    name: "Policy Documents",
    key: "Policy_Documents",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/policyDocuments",
    component: (
      <ProtectedRoute>
        <PolicyDocuments />
      </ProtectedRoute>
    )
  },
  {
    name: "Employee Referral Bonus document",
    key: "EmployeeReferralBonusDocument",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/employeeReferralBonusDocument",
    component: (
      <ProtectedRoute>
        <EmployeeReferralBonusDocument />
      </ProtectedRoute>
    )
  },
  {
    name: "Leave Management",
    key: "leave_Management",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/LMSPolicyDocument",
    component: (
      <ProtectedRoute>
        <LMSPolicyDocument />
      </ProtectedRoute>
    )
  },
  {
    name: "Apply for Leave",
    key: "ApplyLeave",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/applyLeave",
    component: (
      <ProtectedRoute>
        <ApplyLeave />
      </ProtectedRoute>
    )
  },
  {
    name: "Leave Request List",
    key: "LeaveRequestList",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/leaveRequestList",
    component: (
      <ProtectedRoute>
        <LeaveRequestList />
      </ProtectedRoute>
    )
  },
  {
    name: "Generate Compensatory Off",
    key: "GenerateCompensatoryOff",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/generateCompensatoryOff",
    component: (
      <ProtectedRoute>
        <GenerateCompensatoryOff />
      </ProtectedRoute>
    )
  },
  {
    name: "Apply Maternity Leaves",
    key: "ApplyMaternityLeaves",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/applyMaternityLeaves",
    component: (
      <ProtectedRoute>
        <ApplyMaternityLeaves />
      </ProtectedRoute>
    )
  },
  {
    name: "List Compensatory Off",
    key: "ListCompensatoryOff",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/listCompensatoryOff",
    component: (
      <ProtectedRoute>
        <ListCompensatoryOff />
      </ProtectedRoute>
    )
  },
  {
    name: "Leave Application Received",
    key: "LeaveApplicationReceived",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/leaveApplicationReceived",
    component: (
      <ProtectedRoute>
        <LeaveApplicationReceived />
      </ProtectedRoute>
    )
  },
  {
    name: "Compensatory Request Received",
    key: "CompensatoryRequestReceived",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/compensatoryRequestReceived",
    component: (
      <ProtectedRoute>
        <CompensatoryRequestReceived />
      </ProtectedRoute>
    )
  },
  {
    name: "Assign Compensatory Off",
    key: "Assign Compensatory Off",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/assignCompensatoryOff",
    component: (
      <ProtectedRoute>
        <AssignCompensatoryOff />
      </ProtectedRoute>
    )
  },
  {
    name: "Performance Improvement",
    key: "Performance Improvement",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/Performance_Improvement_List",
    component: (
      <ProtectedRoute>
        <Performance_Improvement_List />
      </ProtectedRoute>
    )
  },

  {
    name: "Performance Improvement",
    key: "Performance Improvement",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/performanceImprovementList",
    component: (
      <ProtectedRoute>
        <PerformanceImprovementList />
      </ProtectedRoute>
    )
  },
  {
    name: "Extend Performance Improvement",
    key: "Extend Performance Improvement",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/extendPerformanceImprovement/:empId",
    component: (
      <ProtectedRoute>
        <ExtendPerformanceImprovement />
      </ProtectedRoute>
    )
  },
  {
    name: "End Performance Improvement",
    key: "End Performance Improvement",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/endPerformanceImprovement/:empId",
    component: (
      <ProtectedRoute>
        <EndPerformanceImprovement />
      </ProtectedRoute>
    )
  },
  {
    name: "Probation Period",
    key: "Probation Period",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/employeeProbationReports",
    component: (
      <ProtectedRoute>
        <AdminProbationReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Extend Probation Period",
    key: "Extend Probation Period",
    route: "/empoyeeExtendProbation/:empId",
    component: (
      <ProtectedRoute>
        <AdminExtendProbation />
      </ProtectedRoute>
    )
  },
  {
    name: "End Probation Period",
    key: "End Probation Period",
    route: "/empoyeeEndProbation/:empId",
    component: (
      <ProtectedRoute>
        <AdminEndProbation />
      </ProtectedRoute>
    )
  },

  {
    name: "Probation Period",
    key: "Probation Period",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/employeeProbationList",
    component: (
      <ProtectedRoute>
        <EmployeeProbationList />
      </ProtectedRoute>
    )
  },
  {
    name: "Extend Probation",
    key: "Extend Probation",
    // icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/extend-probation/:empId",
    component: (
      <ProtectedRoute>
        <ExtendProbation />
      </ProtectedRoute>
    )
  },
  {
    name: "End Probation",
    key: "End Probation",
    // icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/end-probation/:empId",
    component: (
      <ProtectedRoute>
        <EndProbation />
      </ProtectedRoute>
    )
  },
  {
    name: "Change Notice Period",
    key: "Change Notice Period",
    // icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/changeNoticePeriod/:empId",
    component: (
      <ProtectedRoute>
        <ChangeNoticePeriod />
      </ProtectedRoute>
    )
  },

  {
    name: "Reporting Employees",
    key: "Reporting Employees",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/reportingEmployees",
    component: (
      <ProtectedRoute>
        <ReportingEmployees />
      </ProtectedRoute>
    )
  },
  {
    name: "Resignation Request",
    key: "Resignation Request",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/Resignation_Request_List",
    component: (
      <ProtectedRoute>
        <Resignation_Request_List />
      </ProtectedRoute>
    )
  },

  {
    name: "Resignation Request List",
    key: "Resignation Request List",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/ResignationRequestList",
    component: (
      <ProtectedRoute>
        <ResignationRequestList />
      </ProtectedRoute>
    )
  },
  {
    name: "Experience Report",
    key: "Experience Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/experienceReport",
    component: (
      <ProtectedRoute>
        <ExperienceReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Experience Report",
    key: "Experience Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/experience_Reports",
    component: (
      <ProtectedRoute>
        <Experience_Reports />
      </ProtectedRoute>
    )
  },
  {
    name: "Reporting List",
    key: "Reporting List",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/reportingList",
    component: (
      <ProtectedRoute>
        <ReportingList />
      </ProtectedRoute>
    )
  },
  {
    name: "Balance Leave Report",
    key: "Balance Leave Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/balanceLeaveReport",
    component: (
      <ProtectedRoute>
        <BalanceLeaveReport />
      </ProtectedRoute>
    )
  },
  {
    name: "LWP Report",
    key: "LWP Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/lwpReport",
    component: (
      <ProtectedRoute>
        <LWPLeaveReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Assign Project Report",
    key: "Assign Project Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/assignprojectReport",
    component: (
      <ProtectedRoute>
        <ProjectReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Biometric Leave Report",
    key: "Biometric Leave Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/biometricLeaveReport",
    component: (
      <ProtectedRoute>
        <BiometricLeaveReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Employee Billing Report",
    key: "Employees Billing Report",
    route: "/employeeBillingReport",
    component: (
      <ProtectedRoute>
        <EmployeeBillingReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Joining Report",
    key: "Joining Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/JoiningReport",
    component: (
      <ProtectedRoute>
        <AdminJoiningReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Technology Report",
    key: "Technology Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/technologyReport",
    component: (
      <ProtectedRoute>
        <TechnologyReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Defaulter List (PA)",
    key: "Defaulter List (PA)",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/defaulterList",
    component: (
      <ProtectedRoute>
        <DefaulterList />
      </ProtectedRoute>
    )
  },
  {
    name: "Temp_biom_data Report",
    key: "Temp_biom_data Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/temp_biom_data",
    component: (
      <ProtectedRoute>
        <Temp_biom_dataReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Employee Attendance Report",
    key: "Employee Attendance Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/employeeAttendanceReport",
    component: (
      <ProtectedRoute>
        <EmployeeAttendanceeReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Employee Roster Report",
    key: "Employee Roster Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/employeeRosterReport",
    component: (
      <ProtectedRoute>
        <EmployeeRosterReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Performance Appraisal",
    key: "Performance Appraisal",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/performanceAppraisalReport",
    component: (
      <ProtectedRoute>
        <PerformanceAppraisalReport />
      </ProtectedRoute>
    )
  },

  {
    name: "Add Performance",
    key: "Add Performance",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/createPerformanceImprovement",
    component: (
      <ProtectedRoute>
        <CreatePerformanceImprovement />
      </ProtectedRoute>
    )
  },

  //   // {
  //   //
  //   //   name: "Sign Up",
  //   //   key: "sign-up",
  //   //   icon: <Icon fontSize="small">assignment</Icon>,
  //   //   route: "/authentication/sign-up",
  //   //   component: <SignUp />,
  //   // },
  {
    name: "Job Vacancy",
    key: "Job Vacancy",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/addJobVacancy",
    component: (
      <ProtectedRoute>
        <AddJobVacancy />
      </ProtectedRoute>
    )
  },
  {
    name: "Job Vacancy",
    key: "Job Vacancy",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/JobVacancylist",
    component: (
      <ProtectedRoute>
        <JobVacancyList />
      </ProtectedRoute>
    )
  },
  {
    name: "Youtube Links",
    key: "Youtube Links",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/addYoutubeLinks",
    component: (
      <ProtectedRoute>
        <AddYoutubeLinks />
      </ProtectedRoute>
    )
  },
  {
    name: "Youtube Links",
    key: "Youtube Links",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/youtubeLinksList",
    component: (
      <ProtectedRoute>
        <YoutubeLinksList />
      </ProtectedRoute>
    )
  },
  {
    name: "Voucher Window",
    key: "Voucher Window",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/voucherWindow",
    component: (
      <ProtectedRoute>
        <VoucherWindow />
      </ProtectedRoute>
    )
  },
  {
    name: "Upload Vouchers",
    key: "Upload Vouchers",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/uploadVouchers",
    component: (
      <ProtectedRoute>
        <UploadVouchers />
      </ProtectedRoute>
    )
  },

  {
    name: "Reporting History",
    key: "Reporting History",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/reporting-history/:empId",
    component: (
      <ProtectedRoute>
        <ReportingHistory />
      </ProtectedRoute>
    )
  },
  {
    name: "Cron Job Links",
    key: "Cron Job Links",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/cron-job-links",
    component: (
      <ProtectedRoute>
        <CronJobLinks />
      </ProtectedRoute>
    )
  },
  {
    name: "Set Permissions",
    key: "Set Permissions",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/EditPermissions",
    component: (
      <ProtectedRoute>
        <SetPermissions />
      </ProtectedRoute>
    )
  },
  {
    name: "Setting",
    key: "setting",
    icon: <Icon fontSize="small">Setting</Icon>,
    route: "/changePassword",
    component: (
      <ProtectedRoute>
        <ChangePassword />
      </ProtectedRoute>
    )
  },

  {
    name: "appraisal",
    key: "appraisal",
    route: "/appraisal",
    component: (
      <ProtectedRoute>
        <PerformanceForm />
      </ProtectedRoute>
    )
  },
  {
    name: "viewRating",
    key: "viewRating",
    route: "/viewrating",
    component: (
      <ProtectedRoute>
        <AppraisalViewRating />
      </ProtectedRoute>
    )
  },

  {
    name: "Reporting Employees List",
    key: "Reporting Employees List",
    route: "/reporting-employees-list",
    component: (
      <ProtectedRoute>
        <ReportingEmployeesList />
      </ProtectedRoute>
    )
  },

  {
    name: "Open KRA Window",
    key: "Open KRA Window",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/openKRAWindow",
    component: (
      <ProtectedRoute>
        <OpenKRAWindow />
      </ProtectedRoute>
    )
  },
  {
    name: "KRA Form Overview",
    key: "KRA Form Overview",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/kraFormOverview",
    component: (
      <ProtectedRoute>
        <KraFormOverview />
      </ProtectedRoute>
    )
  },
  {
    name: "Add Skills",
    key: "Add Skills",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/addSkills",
    component: (
      <ProtectedRoute>
        <AddSkills />
      </ProtectedRoute>
    )
  },
  {
    name: "List Skills",
    key: "List Skills",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/listSkills",
    component: (
      <ProtectedRoute>
        <ListSkills />
      </ProtectedRoute>
    )
  },
  {
    name: "Status Report",
    key: "Status Report",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/statusReport",
    component: (
      <ProtectedRoute>
        <StatusReport />
      </ProtectedRoute>
    )
  },
  {
    name: "Edit KRA Window",
    key: "Edit KRA Window",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/editKRA",
    component: (
      <ProtectedRoute>
        <ExtendKra />
      </ProtectedRoute>
    )
  },

  {
    name: "Default Values",
    key: "Default Values",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/defaultValues",
    component: (
      <ProtectedRoute>
        <DefaultValues />
      </ProtectedRoute>
    )
  },
  {
    name: "Process Attendance Data",
    key: "Process Attendance Data",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/processAttendance",
    component: (
      <ProtectedRoute>
        <ProcessAttendanceData />
      </ProtectedRoute>
    )
  },
  {
    name: "Birthday Template Upload",
    key: "Birthday Template Upload",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/birthdayTemplate",
    component: (
      <ProtectedRoute>
        <BirthdayTemplateUpload />
      </ProtectedRoute>
    )
  },
  {
    name: "Event",
    key: "Event",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/event",
    component: (
      <ProtectedRoute>
        <Event />
      </ProtectedRoute>
    )
  },
  {
    name: "Admin Permissions",
    key: "Admin Permissions",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/adminPermissions",
    component: (
      <ProtectedRoute>
        <AdminPermissions />
      </ProtectedRoute>
    )
  },
  {
    name: "Change Employee Password",
    key: "changeEmployeePassword",
    route: "/changeEmployeePassword",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <ChangeEmployeePassword />
      </ProtectedRoute>
    )
  },
  {
    name: "Component",
    key: "Component",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/components",
    component: (
      <ProtectedRoute>
        <AddComponent />
      </ProtectedRoute>
    )
  },
  {
    name: "New Asset",
    key: "New Asset",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/addAsset",
    component: (
      <ProtectedRoute>
        <AddAsset />
      </ProtectedRoute>
    )
  },
  {
    name: "IT Helpdesk",
    key: "IT Helpdesk",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/it-helpdesk",
    component: (
      <ProtectedRoute>
        <ITHelpdesk />
      </ProtectedRoute>
    )
  },
  {
    name: "Asset List",
    key: "Asset List",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/assetList",
    component: (
      <ProtectedRoute>
        <AssetList />
      </ProtectedRoute>
    )
  },
  {
    name: "Issue Asset",
    key: "Issue Asset",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/issueAsset",
    component: (
      <ProtectedRoute>
        <IssueAsset />
      </ProtectedRoute>
    )
  },
  {
    name: "Receive Asset",
    key: "Receive Asset",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/receiveAsset",
    component: (
      <ProtectedRoute>
        <ReceiveAsset />
      </ProtectedRoute>
    )
  },
  {
    name: "View Asset Details",
    key: "View Asset Details",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/viewAsset",
    component: (
      <ProtectedRoute>
        <ViewAsset />
      </ProtectedRoute>
    )
  },
  {
    name: "Asset History",
    key: "Asset History",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/assets/asset_history/:id",
    component: (
      <ProtectedRoute>
        <AssetHistory />
      </ProtectedRoute>
    )
  },
  {
    name: "Assets History",
    key: "Assets History",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/employeeAssetsHistory",
    component: (
      <ProtectedRoute>
        <EmployeeAssetsHistory />
      </ProtectedRoute>
    )
  },
  {
    name: "Extend Kra For Employee",
    key: "Extend Kra For Employee",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/extend-kra-employee",
    component: (
      <ProtectedRoute>
        <ExtendKraForEmployee />
      </ProtectedRoute>
    )
  },
  {
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />
  },
  {
    name: "Forgot Password",
    key: "forgot-password",
    route: "/authentication/forgot-password",
    component: <ForgotPassword />
  },
  {
    name: "Logout",
    key: "Logout",
    icon: <Icon fontSize="small">Setting</Icon>,
    route: "/logout",
    component: (
      <ProtectedRoute>
        <Logout />
      </ProtectedRoute>
    )
  },
  {
    name: "ExitClearanceForm",
    key: "ExitClearanceForm",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/exitClearanceForm",
    component: (
      <ProtectedRoute>
        <ExitClearanceForm />
      </ProtectedRoute>
    )
  },
  {
    name: "ExitInterviewForm",
    key: "ExitInterviewForm",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/exitInterviewForm",
    component: (
      <ProtectedRoute>
        <ExitInterviewForm />
      </ProtectedRoute>
    )
  },
  {
    name: "IT Clearance List",
    key: "ITClearanceList",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/itClearanceList",
    component: (
      <ProtectedRoute>
        <ITClearanceList />
      </ProtectedRoute>
    )
  },
  {
    name: "Finance Clearance List",
    key: "FinanceClearanceList",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/financeClearanceList",
    component: (
      <ProtectedRoute>
        <FinanceClearanceList />
      </ProtectedRoute>
    )
  },
  {
    name: "Administration Clearance List",
    key: "AdministrationClearanceList",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/administrationClearanceList",
    component: (
      <ProtectedRoute>
        <AdministrationClearanceList />
      </ProtectedRoute>
    )
  },
  {
    name: "HR Clearance List",
    key: "HRClearanceList",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/hrClearanceList",
    component: (
      <ProtectedRoute>
        <HRClearanceList />
      </ProtectedRoute>
    )
  },
  {
    name: "Exit Interview List",
    key: "ExitInterviewList",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/exitInterviewList",
    component: (
      <ProtectedRoute>
        <ExitInterviewList />
      </ProtectedRoute>
    )
  },
  {
    name: "Assign KRA",
    key: "assign-kra",
    route: "/manager/appraisal/assign",
    component: (
      <ProtectedRoute>
        <AssignKRA />
      </ProtectedRoute>
    )
  },
  {
    name: "Confirmation",
    key: "confirmation",
    route: "/manager/appraisal/confirmation",
    component: (
      <ProtectedRoute>
        <ConfirmationPage />
      </ProtectedRoute>
    ),
    hide: true
  },
  {
    name: "Edit KRA",
    key: "edit-Kra",
    route: "/manager/appraisal/edit-goals/:empId",
    component: (
      <ProtectedRoute>
        <EditGoalSettings />
      </ProtectedRoute>
    ),
    hide: true
  },
  {
    name: "Edit KRA",
    key: "edit-Kra",
    route: "/manager/appraisal/edit-goals/:empId",
    component: (
      <ProtectedRoute>
        <EditGoalSettings />
      </ProtectedRoute>
    ),
    hide: true
  },
  {
    name: "View Goal Setting",
    key: "Kra-goal-setting",
    route: "/manager/appraisal/goal-settings/:empId",
    component: (
      <ProtectedRoute>
        <GoalSettingsView />
      </ProtectedRoute>
    ),
    hide: true
  },
  {
    name: "View Employee Appraisal Rating",
    key: "View-Employee-Appraisal-Rating",
    route: "/manager/appraisal/view-ratings/:appraisalId/:empId",
    component: (
      <ProtectedRoute>
        <ViewEmployeeRatings />
      </ProtectedRoute>
    ),
    hide: true
  },
  {
    name: "KRA List",
    key: "KRA List",
    route: "/manager/appraisal/kraList",
    component: (
      <ProtectedRoute>
        <KRAList />
      </ProtectedRoute>
    )
  },
  {
    name: "Admin KRA Form Overview",
    key: "Admin KRA Form Overview",
    route: "/admin/appraisal/admin_kra_form_overview/:appraisalId/:empId",
    icon: <Icon fontSize="small">notifications</Icon>,
    component: (
      <ProtectedRoute>
        <AdminViewAppraisalForm />
      </ProtectedRoute>
    )
  },
  {
    name: "Work Anniversary List",
    key: "Work Anniversary List",
    route: "/work-anniversary",
    icon: <Icon fontSize="small">event</Icon>,
    component: (
      <ProtectedRoute>
        <WorkAnniversaryList />
      </ProtectedRoute>
    )
  }
];

export default routes;
